module.exports = __webpack_public_path__ + "static/media/data_science.8c8ffd56.svg";